export default __webpack_public_path__ + "static/media/thumb-MDS-1.4d34beab.png";